"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ClientMetricReportDirection_1 = require("../clientmetricreport/ClientMetricReportDirection");

var ClientMetricReportMediaType_1 = require("../clientmetricreport/ClientMetricReportMediaType");

var DefaultClientMetricReport_1 = require("../clientmetricreport/DefaultClientMetricReport");

var StreamMetricReport_1 = require("../clientmetricreport/StreamMetricReport");

var MeetingSessionLifecycleEvent_1 = require("../meetingsession/MeetingSessionLifecycleEvent");

var MeetingSessionLifecycleEventCondition_1 = require("../meetingsession/MeetingSessionLifecycleEventCondition");

var IntervalScheduler_1 = require("../scheduler/IntervalScheduler");

var SignalingProtocol_js_1 = require("../signalingprotocol/SignalingProtocol.js");

var Types_1 = require("../utils/Types");

var AudioLogEvent_1 = require("./AudioLogEvent");

var VideoLogEvent_1 = require("./VideoLogEvent");

var DefaultStatsCollector = /*#__PURE__*/function () {
  function DefaultStatsCollector(audioVideoController, logger, browserBehavior) {
    var interval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DefaultStatsCollector.INTERVAL_MS;

    _classCallCheck(this, DefaultStatsCollector);

    this.audioVideoController = audioVideoController;
    this.logger = logger;
    this.browserBehavior = browserBehavior;
    this.interval = interval;
    this.intervalScheduler = null; // TODO: Implement metricsAddTime() and metricsLogEvent().

    this.metricsAddTime = function (_name, _duration, _attributes) {};

    this.metricsLogEvent = function (_name, _attributes) {};
  } // TODO: Update toAttribute() and toSuffix() methods to convert raw data to a required type.


  _createClass(DefaultStatsCollector, [{
    key: "toAttribute",
    value: function toAttribute(str) {
      return this.toSuffix(str).substring(1);
    }
  }, {
    key: "toSuffix",
    value: function toSuffix(str) {
      if (str.toLowerCase() === str) {
        // e.g. lower_case -> _lower_case
        return "_".concat(str);
      } else if (str.toUpperCase() === str) {
        // e.g. UPPER_CASE -> _upper_case
        return "_".concat(str.toLowerCase());
      } else {
        // e.g. CamelCaseWithCAPS -> _camel_case_with_caps
        return str.replace(/([A-Z][a-z]+)/g, function ($1) {
          return "_".concat($1);
        }).replace(/([A-Z][A-Z]+)/g, function ($1) {
          return "_".concat($1);
        }).toLowerCase();
      }
    }
  }, {
    key: "logLatency",
    value: function logLatency(eventName, timeMs, attributes) {
      var event = this.toSuffix(eventName);
      this.logEventTime('meeting' + event, timeMs, attributes);
    }
  }, {
    key: "logStateTimeout",
    value: function logStateTimeout(stateName, attributes) {
      var state = this.toSuffix(stateName);
      this.logEvent('meeting_session_state_timeout', Object.assign(Object.assign({}, attributes), {
        state: "state".concat(state)
      }));
    }
  }, {
    key: "logAudioEvent",
    value: function logAudioEvent(eventName, attributes) {
      var event = 'audio' + this.toSuffix(AudioLogEvent_1.default[eventName]);
      this.logEvent(event, attributes);
    }
  }, {
    key: "logVideoEvent",
    value: function logVideoEvent(eventName, attributes) {
      var event = 'video' + this.toSuffix(VideoLogEvent_1.default[eventName]);
      this.logEvent(event, attributes);
    }
  }, {
    key: "logEventTime",
    value: function logEventTime(eventName, timeMs) {
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var finalAttributes = Object.assign(Object.assign({}, attributes), {
        call_id: this.audioVideoController.configuration.meetingId,
        client_type: DefaultStatsCollector.CLIENT_TYPE,
        metric_type: 'latency'
      });
      this.logger.debug(function () {
        return "[DefaultStatsCollector] ".concat(eventName, ": ").concat(JSON.stringify(finalAttributes));
      });
      this.metricsAddTime(eventName, timeMs, finalAttributes);
    }
  }, {
    key: "logMeetingSessionStatus",
    value: function logMeetingSessionStatus(status) {
      // TODO: Generate the status event name given the status code.
      var statusEventName = "".concat(status.statusCode());
      this.logEvent(statusEventName);
      var statusAttribute = {
        status: statusEventName,
        status_code: "".concat(status.statusCode())
      };
      this.logEvent('meeting_session_status', statusAttribute);

      if (status.isTerminal()) {
        this.logEvent('meeting_session_stopped', statusAttribute);
      }

      if (status.isAudioConnectionFailure()) {
        this.logEvent('meeting_session_audio_failed', statusAttribute);
      }

      if (status.isFailure()) {
        this.logEvent('meeting_session_failed', statusAttribute);
      }
    }
  }, {
    key: "logLifecycleEvent",
    value: function logLifecycleEvent(lifecycleEvent, condition) {
      var attributes = {
        lifecycle_event: "lifecycle".concat(this.toSuffix(MeetingSessionLifecycleEvent_1.default[lifecycleEvent])),
        lifecycle_event_code: "".concat(lifecycleEvent),
        lifecycle_event_condition: "condition".concat(this.toSuffix(MeetingSessionLifecycleEventCondition_1.default[condition])),
        lifecycle_event_condition_code: "".concat(condition)
      };
      this.logEvent('meeting_session_lifecycle', attributes);
    }
  }, {
    key: "logEvent",
    value: function logEvent(eventName) {
      var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var finalAttributes = Object.assign(Object.assign({}, attributes), {
        call_id: this.audioVideoController.configuration.meetingId,
        client_type: DefaultStatsCollector.CLIENT_TYPE
      });
      this.logger.debug(function () {
        return "[DefaultStatsCollector] ".concat(eventName, ": ").concat(JSON.stringify(finalAttributes));
      });
      this.metricsLogEvent(eventName, finalAttributes);
    }
    /**
     * WEBRTC METRICS COLLECTION.
     */

  }, {
    key: "start",
    value: function start(signalingClient, videoStreamIndex, clientMetricReport) {
      var _this = this;

      if (this.intervalScheduler) {
        return false;
      }

      this.logger.info('Starting DefaultStatsCollector');
      this.signalingClient = signalingClient;
      this.videoStreamIndex = videoStreamIndex;

      if (clientMetricReport) {
        this.clientMetricReport = clientMetricReport;
      } else {
        this.clientMetricReport = new DefaultClientMetricReport_1.default(this.logger, this.videoStreamIndex, this.audioVideoController.configuration.credentials.attendeeId);
      }

      this.intervalScheduler = new IntervalScheduler_1.default(this.interval);
      this.intervalScheduler.start(function () {
        _this.getStatsWrapper();
      });
      return true;
    }
  }, {
    key: "stop",
    value: function stop() {
      this.logger.info('Stopping DefaultStatsCollector');

      if (this.intervalScheduler) {
        this.intervalScheduler.stop();
      }

      this.intervalScheduler = null;
    }
    /**
     * Convert raw metrics to client metric report.
     */

  }, {
    key: "updateMetricValues",
    value: function updateMetricValues(rawMetricReport, isStream) {
      var metricReport = isStream ? this.clientMetricReport.streamMetricReports[Number(rawMetricReport.ssrc)] : this.clientMetricReport.globalMetricReport;
      var metricMap;

      if (isStream) {
        metricMap = this.clientMetricReport.getMetricMap(metricReport.mediaType, metricReport.direction);
      } else {
        metricMap = this.clientMetricReport.getMetricMap();
      }

      for (var rawMetric in rawMetricReport) {
        if (rawMetric in metricMap) {
          metricReport.previousMetrics[rawMetric] = metricReport.currentMetrics[rawMetric];
          metricReport.currentMetrics[rawMetric] = rawMetricReport[rawMetric];
        }
      }
    }
  }, {
    key: "processRawMetricReports",
    value: function processRawMetricReports(rawMetricReports) {
      this.clientMetricReport.currentSsrcs = {};
      var timeStamp = Date.now();

      var _iterator = _createForOfIteratorHelper(rawMetricReports),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rawMetricReport = _step.value;
          var isStream = this.isStreamRawMetricReport(rawMetricReport.type);

          if (isStream) {
            var existingStreamMetricReport = this.clientMetricReport.streamMetricReports[Number(rawMetricReport.ssrc)];

            if (!existingStreamMetricReport) {
              var streamMetricReport = new StreamMetricReport_1.default();
              streamMetricReport.mediaType = this.getMediaType(rawMetricReport);
              streamMetricReport.direction = this.getDirectionType(rawMetricReport);

              if (!this.videoStreamIndex.allStreams().empty()) {
                streamMetricReport.streamId = this.videoStreamIndex.streamIdForSSRC(Number(rawMetricReport.ssrc));
              }

              this.clientMetricReport.streamMetricReports[Number(rawMetricReport.ssrc)] = streamMetricReport;
            } else {
              // Update stream ID in case we have overriden it locally in the case of remote video
              // updates completed without a negotiation
              existingStreamMetricReport.streamId = this.videoStreamIndex.streamIdForSSRC(Number(rawMetricReport.ssrc));
            }

            this.clientMetricReport.currentSsrcs[Number(rawMetricReport.ssrc)] = 1;
          }

          this.updateMetricValues(rawMetricReport, isStream);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.clientMetricReport.removeDestroyedSsrcs();
      this.clientMetricReport.previousTimestampMs = this.clientMetricReport.currentTimestampMs;
      this.clientMetricReport.currentTimestampMs = timeStamp;
      this.clientMetricReport.print();
    }
    /**
     * Protobuf packaging.
     */

  }, {
    key: "addMetricFrame",
    value: function addMetricFrame(metricName, clientMetricFrame, metricSpec, ssrc) {
      var type = metricSpec.type;
      var transform = metricSpec.transform;
      var sourceMetric = metricSpec.source;
      var streamMetricFramesLength = clientMetricFrame.streamMetricFrames.length;
      var latestStreamMetricFrame = clientMetricFrame.streamMetricFrames[streamMetricFramesLength - 1];

      if (type) {
        var metricFrame = SignalingProtocol_js_1.SdkMetric.create();
        metricFrame.type = type;
        metricFrame.value = sourceMetric ? transform(sourceMetric, ssrc) : transform(metricName, ssrc);
        ssrc ? latestStreamMetricFrame.metrics.push(metricFrame) : clientMetricFrame.globalMetrics.push(metricFrame);
      }
    }
  }, {
    key: "addGlobalMetricsToProtobuf",
    value: function addGlobalMetricsToProtobuf(clientMetricFrame) {
      var metricMap = this.clientMetricReport.getMetricMap();

      for (var metricName in this.clientMetricReport.globalMetricReport.currentMetrics) {
        this.addMetricFrame(metricName, clientMetricFrame, metricMap[metricName]);
      }
    }
  }, {
    key: "addStreamMetricsToProtobuf",
    value: function addStreamMetricsToProtobuf(clientMetricFrame) {
      for (var ssrc in this.clientMetricReport.streamMetricReports) {
        var streamMetricReport = this.clientMetricReport.streamMetricReports[ssrc];
        var streamMetricFrame = SignalingProtocol_js_1.SdkStreamMetricFrame.create();
        streamMetricFrame.streamId = streamMetricReport.streamId;
        streamMetricFrame.metrics = [];
        clientMetricFrame.streamMetricFrames.push(streamMetricFrame);
        var metricMap = this.clientMetricReport.getMetricMap(streamMetricReport.mediaType, streamMetricReport.direction);

        for (var metricName in streamMetricReport.currentMetrics) {
          this.addMetricFrame(metricName, clientMetricFrame, metricMap[metricName], Number(ssrc));
        }
      }
    }
  }, {
    key: "makeClientMetricProtobuf",
    value: function makeClientMetricProtobuf() {
      var clientMetricFrame = SignalingProtocol_js_1.SdkClientMetricFrame.create();
      clientMetricFrame.globalMetrics = [];
      clientMetricFrame.streamMetricFrames = [];
      this.addGlobalMetricsToProtobuf(clientMetricFrame);
      this.addStreamMetricsToProtobuf(clientMetricFrame);
      return clientMetricFrame;
    }
  }, {
    key: "sendClientMetricProtobuf",
    value: function sendClientMetricProtobuf(clientMetricFrame) {
      this.signalingClient.sendClientMetrics(clientMetricFrame);
    }
    /**
     * Helper functions.
     */

  }, {
    key: "isStreamRawMetricReport",
    value: function isStreamRawMetricReport(type) {
      return type === 'ssrc' || type === 'inbound-rtp' || type === 'outbound-rtp';
    }
  }, {
    key: "getMediaType",
    value: function getMediaType(rawMetricReport) {
      return rawMetricReport.mediaType === 'audio' ? ClientMetricReportMediaType_1.default.AUDIO : ClientMetricReportMediaType_1.default.VIDEO;
    }
  }, {
    key: "getDirectionType",
    value: function getDirectionType(rawMetricReport) {
      return rawMetricReport.id.toLowerCase().indexOf('send') !== -1 || rawMetricReport.id.toLowerCase().indexOf('outbound') !== -1 || rawMetricReport.type === 'outbound-rtp' ? ClientMetricReportDirection_1.default.UPSTREAM : ClientMetricReportDirection_1.default.DOWNSTREAM;
    }
    /**
     * Metric report filter.
     */

  }, {
    key: "isValidChromeRawMetric",
    value: function isValidChromeRawMetric(rawMetricReport) {
      return this.browserBehavior.hasChromiumWebRTC() && (rawMetricReport.type === 'ssrc' || rawMetricReport.type === 'VideoBwe' || rawMetricReport.type === 'googCandidatePair' && rawMetricReport.googWritable === 'true' && rawMetricReport.googReadable === 'true');
    }
  }, {
    key: "isValidStandardRawMetric",
    value: function isValidStandardRawMetric(rawMetricReport) {
      var valid = rawMetricReport.type === 'inbound-rtp' || rawMetricReport.type === 'outbound-rtp' || rawMetricReport.type === 'candidate-pair' && rawMetricReport.state === 'succeeded';

      if (this.browserBehavior.hasFirefoxWebRTC()) {
        if (this.compareMajorVersion(DefaultStatsCollector.FIREFOX_UPDATED_GET_STATS_VERSION) === -1) {
          return valid;
        } else {
          return valid && rawMetricReport.isRemote === false;
        }
      }

      return valid;
    }
  }, {
    key: "isValidSsrc",
    value: function isValidSsrc(rawMetricReport) {
      var validSsrc = true;

      if (this.isStreamRawMetricReport(rawMetricReport.type) && this.getDirectionType(rawMetricReport) === ClientMetricReportDirection_1.default.DOWNSTREAM && this.getMediaType(rawMetricReport) === ClientMetricReportMediaType_1.default.VIDEO) {
        validSsrc = this.videoStreamIndex.streamIdForSSRC(Number(rawMetricReport.ssrc)) > 0;
      }

      return validSsrc;
    }
  }, {
    key: "isValidRawMetricReport",
    value: function isValidRawMetricReport(rawMetricReport) {
      return (this.isValidChromeRawMetric(rawMetricReport) || this.isValidStandardRawMetric(rawMetricReport)) && this.isValidSsrc(rawMetricReport);
    }
  }, {
    key: "filterRawMetricReports",
    value: function filterRawMetricReports(rawMetricReports) {
      var filteredRawMetricReports = [];

      var _iterator2 = _createForOfIteratorHelper(rawMetricReports),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var rawMetricReport = _step2.value;

          if (this.isValidRawMetricReport(rawMetricReport)) {
            filteredRawMetricReports.push(rawMetricReport);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return filteredRawMetricReports;
    }
  }, {
    key: "handleRawMetricReports",
    value: function handleRawMetricReports(rawMetricReports) {
      var _this2 = this;

      var filteredRawMetricReports = this.filterRawMetricReports(rawMetricReports);
      this.logger.debug(function () {
        return "Filtered raw metrics : ".concat(JSON.stringify(filteredRawMetricReports));
      });
      this.processRawMetricReports(filteredRawMetricReports);
      var clientMetricFrame = this.makeClientMetricProtobuf();
      this.sendClientMetricProtobuf(clientMetricFrame);
      this.audioVideoController.forEachObserver(function (observer) {
        Types_1.Maybe.of(observer.metricsDidReceive).map(function (f) {
          return f.bind(observer)(_this2.clientMetricReport.clone());
        });
      });
    }
    /**
     * Get raw webrtc metrics.
     */

  }, {
    key: "getStatsWrapper",
    value: function getStatsWrapper() {
      var _this3 = this;

      if (!this.audioVideoController.rtcPeerConnection) {
        return;
      }

      var rawMetricReports = [];

      if (!this.browserBehavior.requiresPromiseBasedWebRTCGetStats()) {
        // @ts-ignore
        this.audioVideoController.rtcPeerConnection.getStats( // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function (res) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          res.result().forEach(function (report) {
            var item = {};
            report.names().forEach(function (name) {
              item[name] = report.stat(name);
            });
            item.id = report.id;
            item.type = report.type;
            item.timestamp = report.timestamp;
            rawMetricReports.push(item);
          });

          _this3.handleRawMetricReports(rawMetricReports);
        }, // @ts-ignore
        function (error) {
          _this3.logger.error(error.message);
        });
      } else {
        // @ts-ignore
        this.audioVideoController.rtcPeerConnection.getStats().then(function (report) {
          report.forEach(function (item) {
            rawMetricReports.push(item);
          });

          _this3.handleRawMetricReports(rawMetricReports);
        }).catch(function (error) {
          _this3.logger.error(error.message);
        });
      }
    }
  }, {
    key: "compareMajorVersion",
    value: function compareMajorVersion(version) {
      var currentMajorVersion = parseInt(this.browserBehavior.version().split('.')[0]);
      var expectedMajorVersion = parseInt(version.split('.')[0]);

      if (expectedMajorVersion === currentMajorVersion) {
        return 0;
      }

      if (expectedMajorVersion > currentMajorVersion) {
        return 1;
      }

      return -1;
    }
  }]);

  return DefaultStatsCollector;
}();

exports.default = DefaultStatsCollector;
DefaultStatsCollector.INTERVAL_MS = 1000;
DefaultStatsCollector.FIREFOX_UPDATED_GET_STATS_VERSION = '66.0.0';
DefaultStatsCollector.CLIENT_TYPE = 'amazon-chime-sdk-js';